import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CheckoutStore {
        teleconsultationId: string | null;
        selectedPayment: any;
        selectedVoucher: any;

        bindTeleconsultation: (teleconsultationId: string) => void;
        setPayment: (payment: any) => void;
        setVoucher: (voucher: any) => void;
        resetCheckout: () => void;
    }

    export const useCheckoutStore = create<CheckoutStore>()(
    persist(
        (set, get) => ({
            teleconsultationId: null,
            selectedPayment: null,
            selectedVoucher: null,

            bindTeleconsultation: (teleconsultationId) => {
                if (get().teleconsultationId === teleconsultationId) return;
                set({ teleconsultationId, selectedPayment: null, selectedVoucher: null });
            },
            setPayment: (payment) => set({ selectedPayment: payment }),
            setVoucher: (voucher) => set({ selectedVoucher: voucher }),
            resetCheckout: () => set({ teleconsultationId: null, selectedPayment: null, selectedVoucher: null })
        }),
        {
            name: "checkout-storage",
        }
    )
);
